import MetaFieldsPage from './list';

export default MetaFieldsPage;
